/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

import { Module, Node } from '@msdyn365-commerce-modules/utilities';

import {
    IPasswordResetVerificationItem, IPasswordResetVerificationLoading,
    IPasswordResetVerificationLocalAccount, IPasswordResetVerificationViewProps
} from './password-reset-verification';

const PasswordResetVerificationItem: React.FC<IPasswordResetVerificationItem> = ({
    wrapper,
    label,
    errorMessage,
    input
}) => {

    return (
        <Node {...wrapper}>
            {label}
            {errorMessage}
            {input}
        </Node>
    );
};

const LocalAccount: React.FC<IPasswordResetVerificationLocalAccount> = ({
    localAccount,
    verificationControlWrapper,
    items,
    successMessage,
    errorMessage,
    verificationButtonsWrapper,
    verificationButtons,
    buttonsWrapper,
    buttons,
    verificationSuccessModal,
    verificationSuccessModalMessage
}) => {

    return (
        <Node {...localAccount}>
            <Node {...verificationControlWrapper}>
                {items && items.map((item: IPasswordResetVerificationItem) => {
                    return (
                        // tslint:disable-next-line:jsx-key
                        <PasswordResetVerificationItem {...item} />
                    );
                })}
                {successMessage && successMessage.map((message: React.ReactNode, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            {message}
                        </React.Fragment>
                    );
                })}
                {errorMessage && errorMessage.map((error: React.ReactNode, index: number) => {
                    return (
                        <React.Fragment key={index}>
                            {error}
                        </React.Fragment>
                    );
                })}
                <Node {...verificationButtonsWrapper}>
                    {verificationButtons && verificationButtons.map((button: React.ReactNode, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                {button}
                            </React.Fragment>
                        );
                    })}
                </Node>

                <Node {...buttonsWrapper}>
                    {buttons && buttons.map((button: React.ReactNode, index: number) => {
                        return (
                            <React.Fragment key={index}>
                                {button}
                            </React.Fragment>
                        );
                    })}
                </Node>

                <Node {...verificationSuccessModal}>
                    <Node {...verificationSuccessModalMessage} />
                </Node>
            </Node>
        </Node>
    );
};

const PasswordResetVerificationLoading: React.FC<IPasswordResetVerificationLoading> = ({
    modal,
    modalBody,
    icon,
    message,
}) => {
    return (
        <Node {...modal}>
            <Node {...modalBody}>
                {icon}
                {message}
            </Node>
        </Node>
    );
};

const PasswordResetVerificationView: React.FC<IPasswordResetVerificationViewProps> = props => {

    const {
        passwordResetVerification,
        viewState,
        loading,
        defaultAADConainer,
        aadConainer,
        heading,
        passwordResetVerificationLocalAccount
    } = props;

    return (
        <Module {...passwordResetVerification}>
            {viewState.isShowLoading && <Node {...defaultAADConainer} />}
            {viewState.isShowLoading && <PasswordResetVerificationLoading {...loading} />}
            <Node {...aadConainer}>
                {heading}
                {LocalAccount(passwordResetVerificationLocalAccount)}
            </Node>
        </Module>
    );
};

export default PasswordResetVerificationView;
